import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import PubSub from 'pubsub-js';

export const OPEN_HINT_DIALOG = 'openHintDialog';

function HintDialog({title}) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState();

  const onOpen = () => {
    setOpen(true);
  }

  const onClose = () => {
    setOpen(false);
  }

  useEffect(() => {
    const token = PubSub.subscribe(OPEN_HINT_DIALOG, (msg, data) => {
      setContent(data)
      onOpen();
    });
    return () => PubSub.unsubscribe(token);
  }, [])

  return <>
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions onClick={onClose}>關閉</DialogActions>
  </Dialog>
  </>
}

export default HintDialog;